<template>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <!-- 📅 PLANNING JOUR -->
        <div>
            <template v-if="loadingGetData || loadingGetTrajet">
                <div class="flex items-center justify-center h-64">
                    <i class="fas fa-spinner fa-spin text-2xl text-gray-500"></i>
                </div>
            </template>
            <template v-if="!loadingGetData && !loadingGetTrajet">
                <template v-if="date">
                    <intervention-planning-day-events
                        :date="date"
                        :events="planningEvents"
                        @move="onEventMoved"
                    />
                </template>
                <template v-else>
                    <p class="text-gray-600">
                        Sélectionnez une date pour voir le planning.
                    </p>
                </template>
            </template>
        </div>

        <!-- 📝 FORMULAIRE -->
        <div class="space-y-4">
            <!-- 🧾 INFOS INTERVENTION -->
            <div class="bg-slate-50 border border-slate-200 rounded-lg p-4 text-sm">
                <div class="font-semibold text-slate-900 mb-2 text-lg">
                    Intervention à planifier
                </div>
                <ul class="space-y-1 text-slate-500">
                    <li>
                        <strong>Référence:</strong> {{ intervention.reference }}
                    </li>
                    <li>
                        <strong>Durée:</strong> {{ intervention.duree_estimee }} min
                    </li>
                    <li>
                        <strong>Type d'intervention:</strong> {{ intervention.type }}
                    </li>
                    <li>
                        <strong>Client:</strong> {{ intervention.client }}
                    </li>
                    <li>
                        <strong>Adresse:</strong> {{ intervention.adresse }}
                    </li>
                </ul>
            </div>
            
            <div class="min-h-[1836px]" :class="{ 'opacity-50 pointer-events-none': loadingSubmit }">
                <div class="bg-slate-50 border border-slate-200 rounded-lg p-4 text-sm">
                    <div class="font-semibold text-slate-900 mb-2 text-lg">
                        Détails de la planification
                    </div>
                    <!-- Choix technicien -->
                    <div v-if="!isIndependant" class="mb-4">
                        <label class="block text-sm font-medium mb-1">Technicien</label>
                        <select v-model="technicienId" class="border px-3 py-2 rounded w-full">
                            <option value="">Choisir un technicien</option>
                            <option v-for="t in techniciens" :key="t.id" :value="t.id">
                                {{ t.prenom }} {{ t.nom }}
                            </option>
                        </select>
                    </div>

                    <div class="grid grid-cols-2 gap-4">
                        <!-- Date -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Date</label>
                            <div class="datepicker-compact">
                                <datepicker v-model="selectedDate" :inline="true" :monday-first="true" :language="fr" :disabled-dates="disabledDates" />
                            </div>
                        </div>

                        <div v-if="date">
                            <!-- Heure début -->
                            <div>
                                <label class="block text-sm font-medium mb-1">Heure de début</label>
                                <input type="time" v-model="heureDebut" class="border px-3 py-2 rounded w-full" :min="openingHour" :max="closingHour" />
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="isInPast" class="bg-red-50 border border-red-200 rounded-lg p-4 mt-4">
                    <div class="flex items-start gap-3">
                        <i class="fas fa-exclamation-circle text-red-500 mt-0.5"></i>
                        <div>
                            <p class="text-sm font-medium text-red-800">
                                Planification impossible
                            </p>
                            <p class="text-sm text-red-600 mt-1">
                                Vous ne pouvez pas planifier une intervention dans le passé.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- <div class="mt-4 max-h-[400px] overflow-y-auto" v-if="bestSlots && bestSlots.length">
                    <div class="space-y-3">
                        <div 
                            v-for="slot in bestSlots" 
                            :key="`${slot.technicien_id}-${slot.date}-${slot.heure_debut}`" 
                            class="bg-white border-2 border-green-200 rounded-lg p-4 hover:border-green-400 hover:shadow-md transition-all cursor-pointer group"
                            @click="selectSlot(slot)"
                        >
                            <div class="flex items-start justify-between gap-3">
                                <div class="flex items-start gap-3 flex-1">
                                    <div class="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                                        <i class="fas fa-lightbulb text-green-600 text-lg"></i>
                                    </div>
                                    <div class="flex-1">
                                        <div class="flex items-center gap-2 mb-1">
                                            <span class="text-sm font-semibold text-green-800">Créneau optimal</span>
                                            <span class="px-2 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded">
                                                Recommandé
                                            </span>
                                        </div>
                                        
                                        <div class="space-y-1.5 mt-2 grid grid-cols-2 gap-4">
                                            <div class="flex items-center gap-2 text-sm text-slate-700">
                                                <i class="fas fa-user text-slate-400 w-4"></i>
                                                <span class="font-medium">{{ slot.technicien.prenom }} {{ slot.technicien.nom }}</span>
                                            </div>
                                            <div>
                                                <div class="flex items-center gap-2 text-sm text-slate-700">
                                                    <i class="fas fa-calendar text-slate-400 w-4"></i>
                                                    <span>{{ slot.date | momentDate }}</span>
                                                </div>
                                                
                                                <div class="flex items-center gap-2 text-sm text-slate-700">
                                                    <i class="fas fa-clock text-slate-400 w-4"></i>
                                                    <span>{{ slot.heure_debut.slice(0, 5) }} - {{ slot.heure_fin.slice(0, 5) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="flex items-center gap-3 mt-3 pt-3 border-t border-green-100">
                                            <div class="flex items-center gap-1.5 text-xs text-green-600 font-bold">
                                                Trajet:
                                            </div>
                                            <div class="flex items-center gap-1.5 text-xs text-green-600">
                                                <i class="fas fa-stopwatch"></i>
                                                <span class="font-medium">{{ slot.score.delta_time_minutes }} min</span>
                                            </div>
                                            <div class="flex items-center gap-1.5 text-xs text-green-600">
                                                <i class="fas fa-route"></i>
                                                <span class="font-medium">{{ slot.score.delta_distance_km }} km</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <i class="fas fa-chevron-right text-green-400 group-hover:text-green-600 transition-colors"></i>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="mt-4 max-h-[400px] overflow-y-auto" v-if="nearestItems && nearestItems.length">
                    <div class="space-y-3">
                        <div
                            v-for="item in nearestItems"
                            :key="`${item.technicien_id}-${item.date}-${item.heure_debut}-${item.intervention_id}`"
                            class="bg-white border-2 border-blue-200 rounded-lg p-4 hover:border-blue-400 hover:shadow-md transition-all cursor-pointer group"
                            @click="selectSlot(item)"
                        >
                            <div class="flex items-start justify-between gap-3">
                                <div class="flex items-start gap-3 flex-1">
                                    <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                                        <i class="fas fa-route text-blue-600 text-lg"></i>
                                    </div>

                                    <div class="flex-1">
                                        <div class="flex items-center gap-2 mb-1">
                                            <span class="text-sm font-semibold text-blue-800">Intervention la plus proche</span>
                                        </div>

                                        <div class="space-y-1.5 mt-2 grid grid-cols-2 gap-4">
                                            <div class="flex items-center gap-2 text-sm text-slate-700">
                                                <i class="fas fa-user text-slate-400 w-4"></i>
                                                <span class="font-medium">{{ item.technicien }}</span>
                                            </div>

                                            <div>
                                                <div class="flex items-center gap-2 text-sm text-slate-700">
                                                    <i class="fas fa-calendar text-slate-400 w-4"></i>
                                                    <span>{{ item.date | momentDate }}</span>
                                                </div>

                                                <div class="flex items-center gap-2 text-sm text-slate-700">
                                                    <i class="fas fa-clock text-slate-400 w-4"></i>
                                                    <span>{{ item.heure_debut.slice(0, 5) }} - {{ item.heure_fin.slice(0, 5) }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="flex items-center gap-3 mt-3 pt-3 border-t border-blue-100">
                                            <div class="flex items-center gap-1.5 text-xs text-blue-600 font-bold">
                                                Trajet:
                                            </div>

                                            <div class="flex items-center gap-1.5 text-xs text-blue-600">
                                                <i class="fas fa-stopwatch"></i>
                                                <span class="font-medium">{{ item.travel.duration_minutes }} min</span>
                                            </div>

                                            <div class="flex items-center gap-1.5 text-xs text-blue-600">
                                                <i class="fas fa-route"></i>
                                                <span class="font-medium">{{ item.travel.distance_km }} km</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <i class="fas fa-chevron-right text-blue-400 group-hover:text-blue-600 transition-colors"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Actions -->
                <div v-if="!isInPast" class="bg-white border border-slate-200 rounded-lg p-4 mt-4 shadow-sm">
                    <div class="flex items-center justify-between">
                        <!-- Heure fin -->
                        <div class="text-sm text-slate-600 space-y-1">
                            <div class="flex items-center gap-2">
                                <i class="fas fa-clock text-slate-400"></i>
                                <span>
                                    Durée estimée : 
                                    <strong class="text-slate-900">{{ intervention.duree_estimee }} minutes</strong>
                                </span>
                            </div>
                            <div class="flex items-center gap-2">
                                <i class="fas fa-calendar-check text-slate-400"></i>
                                <span>
                                    Fin prévue : 
                                    <strong class="text-slate-900">{{ heureFinCalculee || '-' }}</strong>
                                </span>
                            </div>
                        </div>

                        <!-- Bouton -->
                        <button
                            :disabled="!canSubmit || loadingSubmit"
                            @click="submit"
                            class="px-6 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <template v-if="loadingSubmit">
                                <i class="fas fa-spinner fa-spin"></i>
                                <span>Planification...</span>
                            </template>
                            <template v-else>
                                <i class="fas fa-calendar-plus"></i>
                                <span>Planifier</span>
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import {fr} from 'vuejs-datepicker/dist/locale'
import InterventionPlanningDayEvents from './InterventionPlanningDayEvents.vue';

export default {
    props: {
        intervention: { type: Object, required: true }
    },

    components: {
        InterventionPlanningDayEvents,
        Datepicker
    },

    data() {
        return {
            fr: fr,
            techniciens: [],
            technicienId: null,

            selectedDate: new Date(),
            date: null,
            heureDebut: "08:00",

            planningInterventions: [],
            planningEvents: [],

            timeoutTrajet: null,
            tempsTrajet: null,
            tempsTrajetRetour: null,

            timeoutSendPlanning: null,

            // bestSlots: [],
            nearestItems: [],

            loadingSubmit: false,
            loadingGetData: false,
            loadingGetTrajet: false
        };
    },

    filters: {
        momentDate(value) {
            if (!value) {
                return '-';
            }
            return moment(value).format('DD/MM/YYYY');
        }
    },

    computed: {
        isIndependant() {
            return this.$account.account.societe.independant == 1;
        },

        todayDate() {
            return new Date().toISOString().slice(0, 10);
        },

        previewIntervention() {
            if (!this.date || !this.heureDebut || !this.heureFinCalculee) {
                return null;
            }

            return {
                id: this.intervention.id,
                reference: this.intervention.reference,
                adresse: this.intervention.adresse,
                client_adresse: this.intervention.client_adresse,

                date_intervention: this.date,
                heure_debut: this.heureDebut,
                heure_fin: this.heureFinCalculee,

                trajet_distance_km: this.tempsTrajet ? this.tempsTrajet.distance_km : null,
                trajet_temps: this.tempsTrajet ? this.tempsTrajet.duration_minutes : null,
                trajet_distance_km_retour: this.tempsTrajetRetour ? this.tempsTrajetRetour.distance_km : null,
                trajet_temps_retour: this.tempsTrajetRetour ? this.tempsTrajetRetour.duration_minutes : null
            };
        },

        canSubmit() {
            if (!this.date || !this.heureDebut || !this.heureFinCalculee) return false;
            if (this.isInPast) return false;
            if (!this.isIndependant && !this.technicienId) return false;
            return true;
        },

        heureFinCalculee() {
            if (!this.heureDebut || !this.intervention.duree_estimee) return null;

            const [h, m] = this.heureDebut.split(":").map(Number);
            const start = new Date();
            start.setHours(h, m, 0, 0);

            const minutes = parseInt(this.intervention.duree_estimee, 10);
            start.setMinutes(start.getMinutes() + minutes);

            const hh = String(start.getHours()).padStart(2, "0");
            const mm = String(start.getMinutes()).padStart(2, "0");

            return `${hh}:${mm}`;
        },

        isInPast() {
            if (!this.date || !this.heureDebut) return true;

            const now = new Date();
            const selected = new Date(`${this.date}T${this.heureDebut}:00`);

            return selected < now;
        },

        disabledDates() {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return {
                to: new Date(today.getTime() - 86400000) // hier inclus
            };
        },

        openingHour() {
            const hour = this.$account.account.societe.heure_ouverture;
            if (!hour) return "00:00";
            // Si déjà au format HH:MM, retourner tel quel
            if (hour.includes(":")) return hour.slice(0, 5);
            // Sinon, formater (ex: "8" -> "08:00")
            return String(hour).padStart(2, "0") + ":00";
        },

        closingHour() {
            const hour = this.$account.account.societe.heure_fermeture;
            if (!hour) return "23:59";
            // Si déjà au format HH:MM, retourner tel quel
            if (hour.includes(":")) return hour.slice(0, 5);
            // Sinon, formater (ex: "18" -> "18:00")
            return String(hour).padStart(2, "0") + ":00";
        }
    },

    methods: {
        async fetchTechniciens() {
            const res = await this.$request.get("/techniciens");
            this.techniciens = res;
            if (this.isIndependant && res.length === 1) {
                this.technicienId = res[0].id;
            }
        },

        // async fetchPlanning() {
        //     if (!this.date || !this.technicienId) {
        //         this.planningInterventions = [];
        //         return;
        //     }
        //     this.loadingGetData = true;
        //     const res = await this.$request.post("/interventions/planned", {
        //         date: this.date,
        //         technicien_id: this.technicienId
        //     });
        //     this.loadingGetData = false;
        //     this.planningInterventions = res;

        //     // this.getBetweenInterventions();
        // },

        async submit() {
            if (this.loadingSubmit) return;

            this.loadingSubmit = true;

            const surrounding = this.getSurroundingInterventions();

            try {
                // await this.$request.post(`/interventions/${this.intervention.id}/planifier`, {
                //     technicien_id: this.technicienId,
                //     date_intervention: this.date,
                //     heure_debut: this.heureDebut,
                //     heure_fin: this.heureFinCalculee,
                //     intervention_before: surrounding.before ? JSON.stringify(surrounding.before) : null,
                //     intervention_after: surrounding.after ? JSON.stringify(surrounding.after) : null,
                //     trajet_distance_km: this.previewIntervention.trajet_distance_km,
                //     trajet_temps: this.previewIntervention.trajet_temps,
                //     trajet_distance_km_retour: this.previewIntervention.trajet_distance_km_retour,
                //     trajet_temps_retour: this.previewIntervention.trajet_temps_retour
                // });

                await this.$request.post(`/interventions/${this.intervention.id}/planifier`, {
                    date: this.date,
                    technicien_id: this.technicienId,
                    events: typeof this.planningEvents === "string" ? this.planningEvents : JSON.stringify(this.planningEvents),
                })

                this.$toast.success("Intervention planifiée");
                this.$emit("planned");
                this.$eventHub.$emit('refresh-pastilles', 'interventions_a_planifier');
            } catch (e) {
                this.$toast.error("Erreur lors de la planification");
            } finally {
                this.loadingSubmit = false;
            }
        },

        getSurroundingInterventions() {
            // 🔁 Clone + tri par heure de début
            const sorted = [...this.planningInterventions].sort((a, b) => {
                return a.heure_debut.localeCompare(b.heure_debut)
            })

            const previewStart = this.previewIntervention.heure_debut

            let before = null
            let after = null

            for (let i = 0; i < sorted.length; i++) {
                const current = sorted[i]

                if (current.heure_fin <= previewStart) {
                    before = current
                }

                if (!after && current.heure_debut >= previewStart) {
                    after = current
                    break
                }
            }

            return { before, after }
        },

        async refreshPlanningDay() {
            if (!this.date || !this.technicienId || !this.heureDebut || !this.heureFinCalculee) {
                return;
            }

            this.loadingGetData = true;
            
            clearTimeout(this.timeoutSendPlanning);
                this.timeoutSendPlanning = setTimeout(async () => {
                    let response = await this.$request.post('/planning/day-new-event', {
                        date: this.date,
                        heure_debut: this.heureDebut,
                        heure_fin: this.heureFinCalculee,
                        technicien_id: this.technicienId,
                        intervention_id: this.intervention.id
                });

                this.planningEvents = response;

                this.loadingGetData = false;
            }, 300);
        },

        async getBestSlots() {
            let response = await this.$request.post('planning/best-slots4', {
                intervention_id: this.intervention.id,
            })
            // this.bestSlots = response
            this.nearestItems = response.items
        },

        selectSlot(slot) {
            this.technicienId = slot.technicien_id;
            this.date = slot.date;
            this.heureDebut = slot.estimated.heure_debut;
            // this.heureFinCalculee sera recalculée automatiquement grâce au computed
        },

        onEventMoved(event) {
            // Mettre à jour les heures de l'intervention déplacée
            this.heureDebut = event.event.start.toString().slice(11, 16);

            // Recalculer les trajets autour de l'intervention déplacée
            // this.getBetweenInterventions();
            this.$nextTick(() => {
                this.refreshPlanningDay();
            })
        },

        // async getBetweenInterventions() {
        //     if (this.timeoutTrajet) {
        //         clearTimeout(this.timeoutTrajet);
        //     }
        //     this.loadingGetTrajet = true;
        //     this.tempsTrajet = null;
        //     this.tempsTrajetRetour = null;
        //     try {
        //         this.timeoutTrajet = setTimeout(async () => {
        //             let interventions = this.getSurroundingInterventions();
        //             let interventionsBetween = {...interventions}

        //             if (!interventionsBetween.before) {
        //                 interventionsBetween.before = {
        //                     adresse: {
        //                         latitude: this.$account.account.adresse_depart.latitude,
        //                         longitude: this.$account.account.adresse_depart.longitude
        //                     }
        //                 };
        //             }
        //             if (!interventionsBetween.after) {
        //                 interventionsBetween.after = {
        //                     adresse: {
        //                         latitude: this.$account.account.adresse_retour.latitude,
        //                         longitude: this.$account.account.adresse_retour.longitude
        //                     }
        //                 };
        //             }
                    
        //             // Trajet entre intervention
        //             if (interventions.after && interventions.before) {
        //                 console.log('Entre deux interventions');
                        
        //                 let trajet1 = {
        //                     depart_lat: interventionsBetween.before.adresse.latitude,
        //                     depart_lng: interventionsBetween.before.adresse.longitude,
        //                     arrivee_lat: this.previewIntervention.client_adresse.latitude,
        //                     arrivee_lng: this.previewIntervention.client_adresse.longitude
        //                 };
        //                 let responseTrajet1 = await this.$request.post('maps/travel-data', trajet1);

        //                 let trajet2 = {
        //                     depart_lat: this.previewIntervention.client_adresse.latitude,
        //                     depart_lng: this.previewIntervention.client_adresse.longitude,
        //                     arrivee_lat: interventionsBetween.after.adresse.latitude,
        //                     arrivee_lng: interventionsBetween.after.adresse.longitude
        //                 };
        //                 let responseTrajet2 = await this.$request.post('maps/travel-data', trajet2);

        //                 this.tempsTrajet = responseTrajet1
        //                 this.tempsTrajetRetour = null

        //                 // Changer l'heure de l'internvention d'après
        //                 let interventionAfter = this.planningInterventions.find(i => i.id === interventions.after.id);
        //                 if (interventionAfter) {
        //                     interventionAfter.trajet_temps = responseTrajet2.duration_minutes;
        //                     interventionAfter.trajet_distance_km = responseTrajet2.distance_km;
        //                 }
        //             }

        //             // Dernière intervention de la journée
        //             if (!interventions.after && interventions.before) {
        //                 console.log('Dernière intervention de la journée');

        //                 // Changer le temps de trajet de l'intervention d'avant
        //                 let trajet1 = {
        //                     depart_lat: interventionsBetween.before.adresse.latitude,
        //                     depart_lng: interventionsBetween.before.adresse.longitude,
        //                     arrivee_lat: this.previewIntervention.client_adresse.latitude,
        //                     arrivee_lng: this.previewIntervention.client_adresse.longitude
        //                 };
        //                 let responseTrajet1 = await this.$request.post('maps/travel-data', trajet1);
                        
        //                 // Trajet retour de l'intervention en preview
        //                 let trajet2 = {
        //                     depart_lat: this.previewIntervention.client_adresse.latitude,
        //                     depart_lng: this.previewIntervention.client_adresse.longitude,
        //                     arrivee_lat: interventionsBetween.after.adresse.latitude,
        //                     arrivee_lng: interventionsBetween.after.adresse.longitude
        //                 };
        //                 let responseTrajet2 = await this.$request.post('maps/travel-data', trajet2);

        //                 // Intervention before
        //                 let interventionBefore = this.planningInterventions.find(i => i.id === interventions.before.id);
                        
        //                 if (interventionBefore) {
        //                     interventionBefore.trajet_temps_retour = responseTrajet1.duration_minutes;
        //                     interventionBefore.trajet_distance_km_retour = responseTrajet1.distance_km;
        //                 }
        //                 this.tempsTrajet = null
        //                 this.tempsTrajetRetour = responseTrajet2
        //             }

        //             // Première intervention de la journée
        //             if (interventions.after && !interventions.before) {
        //                 console.log('Première intervention de la journée');

        //                 // Changer le temps de trajet de l'intervention d'après
        //                 let trajet1 = {
        //                     depart_lat: this.$account.account.adresse_depart.latitude,
        //                     depart_lng: this.$account.account.adresse_depart.longitude,
        //                     arrivee_lat: this.previewIntervention.client_adresse.latitude,
        //                     arrivee_lng: this.previewIntervention.client_adresse.longitude
        //                 };
        //                 let responseTrajet1 = await this.$request.post('maps/travel-data', trajet1);
                        
        //                 // Trajet retour de l'intervention en preview
        //                 let trajet2 = {
        //                     depart_lat: this.previewIntervention.client_adresse.latitude,
        //                     depart_lng: this.previewIntervention.client_adresse.longitude,
        //                     arrivee_lat: interventionsBetween.after.adresse.latitude,
        //                     arrivee_lng: interventionsBetween.after.adresse.longitude
        //                 };
        //                 let responseTrajet2 = await this.$request.post('maps/travel-data', trajet2);

        //                 this.tempsTrajet = responseTrajet1
        //                 this.tempsTrajetRetour = null
                        
        //                 // Changer l'heure de l'internvention d'après
        //                 let interventionAfter = this.planningInterventions.find(i => i.id === interventions.after.id);
        //                 if (interventionAfter) {
        //                     interventionAfter.trajet_temps = responseTrajet2.duration_minutes;
        //                     interventionAfter.trajet_distance_km = responseTrajet2.distance_km;
        //                 }
        //             }

        //             // Seule intervention de la journée
        //             if (!interventions.after && !interventions.before) {
        //                 console.log('Seule intervention de la journée');

        //                 // Trajet vers l'intervention
        //                 let trajet1 = {
        //                     depart_lat: this.$account.account.adresse_depart.latitude,
        //                     depart_lng: this.$account.account.adresse_depart.longitude,
        //                     arrivee_lat: this.previewIntervention.client_adresse.latitude,
        //                     arrivee_lng: this.previewIntervention.client_adresse.longitude
        //                 };
        //                 let responseTrajet1 = await this.$request.post('maps/travel-data', trajet1);
                        
        //                 // Trajet retour de l'intervention en preview
        //                 let trajet2 = {
        //                     depart_lat: this.previewIntervention.client_adresse.latitude,
        //                     depart_lng: this.previewIntervention.client_adresse.longitude,
        //                     arrivee_lat: this.$account.account.adresse_retour.latitude,
        //                     arrivee_lng: this.$account.account.adresse_retour.longitude
        //                 };
        //                 let responseTrajet2 = await this.$request.post('maps/travel-data', trajet2);

        //                 this.tempsTrajet = responseTrajet1
        //                 this.tempsTrajetRetour = responseTrajet2
        //             }
        //         }, 800);
        //     } catch (error) {
        //         console.log(error);
        //     }
        //     this.loadingGetTrajet = false;
        // }
    },

    watch: {
        selectedDate(newDate) {
            if (!newDate) {
                this.date = null;
                return;
            }

            // YYYY-MM-DD (propre, API-friendly)
            this.date = newDate.toISOString().slice(0, 10);

            // this.getBetweenInterventions()
            this.refreshPlanningDay()
        },

        heureDebut() {
            // this.getBetweenInterventions()
            this.refreshPlanningDay()
        },

        date() {
            this.refreshPlanningDay();
        },

        technicienId() {
            this.refreshPlanningDay();
        }
    },

    async mounted() {
        this.selectedDate = new Date();
        const now = new Date();
        const hh = String(now.getHours() + 1).padStart(2, "0");
        const mm = "00";
        const proposedTime = `${hh}:${mm}`;

        const heureFermeture = this.$account.account.societe.heure_fermeture;

        if (proposedTime > heureFermeture) {
            // Demain première heure
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.selectedDate = tomorrow;
            const heureOuverture = this.$account.account.societe.heure_ouverture;
            const [h] = heureOuverture.split(':');
            this.heureDebut = `${String(parseInt(h) + 1).padStart(2, '0')}:00`;
        } else {
            this.heureDebut = proposedTime;
        }

        await this.fetchTechniciens();
        await this.refreshPlanningDay();
        await this.getBestSlots();
    }
};

</script>

<style scoped>
.vdp-datepicker__calendar {
    width: 100% !important;
}

</style>